import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../../assets/promiseFrame/nevsCardLineBlue.png'
import _imports_1 from '../../../../../assets/promiseFrame/268Logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-41626972")

_pushScopeId("data-v-41626972")
const _hoisted_1 = { class: "nevsCard" }
const _hoisted_2 = { class: "cardBox" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("车况检测 ")
const _hoisted_4 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("电池检测 ")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_8 = { class: "cardCont" }
const _hoisted_9 = { class: "cardContItem cardContBlue" }
const _hoisted_10 = { class: "cardLevel" }
const _hoisted_11 = { class: "resbox" }
const _hoisted_12 = { class: "rectangle_resBox" }
const _hoisted_13 = { class: "rectangle_resBox_item" }
const _hoisted_14 = { class: "rectangle_resBox_item_txt" }
const _hoisted_15 = { class: "rectangle_resBox_item" }
const _hoisted_16 = { class: "rectangle_resBox_item_txt" }
const _hoisted_17 = { class: "rectangle_resBox_item" }
const _hoisted_18 = { class: "rectangle_resBox_item_txt" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "nevsCardLine" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_20 = { class: "resultTxt" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "resTag" }, "检测结果", -1)
const _hoisted_22 = { class: "cardContItem cardContGreen" }
const _hoisted_23 = { class: "cardLevel" }
const _hoisted_24 = { class: "levelTxt" }
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "iconfont icon-yiwen" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "resbox" }, " 本检测产品的电池健康度是采用国标GB/T27930的协议数据，根据总衰减值计算电池健康度。SOH电池健康度算法已获得国家知识产权局颁布的发明专利。 ", -1)
const _hoisted_27 = { class: "cardResult" }
const _hoisted_28 = { class: "cardResTop" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("循环充电次数")
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("预估满电续航")
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "reportMsgCont" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "localIcon",
    src: _imports_1
  })
], -1)
const _hoisted_35 = { class: "reportMsg" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "batteryPop" }
const _hoisted_38 = { class: "batteryPopTitle" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 电池检测评分说明 ")
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"batteryPopCont\" data-v-41626972><div class=\"batteryPopContTitle\" data-v-41626972><i class=\"batteryPopContTitleLine\" data-v-41626972></i><span class=\"batteryPopContTitleTxt\" data-v-41626972>电池健康度评级</span></div><div class=\"batteryPopContTxt\" data-v-41626972> SOH（State of Health)：指电池健康状态，以百分比表示。SOH=（动力电池当前最大容量÷动力电池额定容量）*100%。 </div><div class=\"batteryPopTable\" data-v-41626972><div class=\"batteryPopTableTh\" data-v-41626972>268V SOH评级</div><div class=\"batteryPopTableTr\" data-v-41626972><div class=\"batteryPopTableTd col1\" data-v-41626972>优秀</div><div class=\"batteryPopTableTd col2\" data-v-41626972>90%（含）以上</div></div><div class=\"batteryPopTableTr\" data-v-41626972><div class=\"batteryPopTableTd col1\" data-v-41626972>良好</div><div class=\"batteryPopTableTd col2\" data-v-41626972>80（含）-90%</div></div><div class=\"batteryPopTableTr\" data-v-41626972><div class=\"batteryPopTableTd col1\" data-v-41626972>中等</div><div class=\"batteryPopTableTd col2\" data-v-41626972>65（含）-80%</div></div><div class=\"batteryPopTableTr\" data-v-41626972><div class=\"batteryPopTableTd col1\" data-v-41626972>一般</div><div class=\"batteryPopTableTd col2\" data-v-41626972>65%以下</div></div><div class=\"batteryPopTableTend\" data-v-41626972> 注：动力电池SOH实测数值为百分比，动力电池评级展示时只展示百分比前方数值。 </div></div></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["cardTab", {'activeGreen': _ctx.state.activeTab === 1,
                'activeBlue': _ctx.state.activeTab === 0
            }]
      }, [
        _createVNode("div", {
          class: ["cardTabItem", {'active': _ctx.state.activeTab === 0}],
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTab(0)))
        }, [
          _createVNode("p", null, [
            _hoisted_3,
            _createVNode("b", null, _toDisplayString(_ctx.getData('rank')), 1)
          ]),
          _hoisted_4
        ], 2),
        _createVNode("div", {
          class: ["cardTabItem", {'active': _ctx.state.activeTab === 1}],
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTab(1)))
        }, [
          _createVNode("p", null, [
            _hoisted_5,
            (_ctx.getData('soh') !== '-')
              ? (_openBlock(), _createBlock("b", _hoisted_6, _toDisplayString(_ctx.getData('soh')), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_7
        ], 2)
      ], 2),
      _createVNode("div", _hoisted_8, [
        _withDirectives(_createVNode("div", _hoisted_9, [
          (_ctx.getData("rank") !== "D")
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "cardService",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toExplain()))
              }, _toDisplayString(_ctx.getData('serviceOneTitleH5')), 1))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_10, [
            _createVNode("img", {
              class: "levelImg",
              src: require(`../../../../../assets/batteryFrame/nevs_level_${_ctx.getData('rank')}.png`)
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_11, [
              _createVNode("ul", _hoisted_12, [
                _createVNode("li", _hoisted_13, [
                  _createVNode("img", {
                    src: require(`../../../../../assets/promiseFrame/${_ctx.getData('accidentFlag', 'additionUrl')}`),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("p", _hoisted_14, _toDisplayString(_ctx.getData('accidentFlag')), 1)
                ]),
                _createVNode("li", _hoisted_15, [
                  _createVNode("img", {
                    src: require(`../../../../../assets/promiseFrame/${_ctx.getData('fireFlag', 'additionUrl')}`),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("p", _hoisted_16, _toDisplayString(_ctx.getData('fireFlag')), 1)
                ]),
                _createVNode("li", _hoisted_17, [
                  _createVNode("img", {
                    src: require(`../../../../../assets/promiseFrame/${_ctx.getData('waterFlag', 'additionUrl')}`),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("p", _hoisted_18, _toDisplayString(_ctx.getData('waterFlag')), 1)
                ])
              ])
            ])
          ]),
          _hoisted_19,
          _createVNode("div", _hoisted_20, [
            _hoisted_21,
            _createTextVNode(" " + _toDisplayString(_ctx.getData('rankDesc')), 1)
          ])
        ], 512), [
          [_vShow, _ctx.state.activeTab === 0]
        ]),
        _withDirectives(_createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, [
            _createVNode("div", {
              class: "reportLevel",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeBatteryPop && _ctx.changeBatteryPop(...args)))
            }, [
              _createVNode("h5", _hoisted_24, _toDisplayString(_ctx.getData('soh')), 1),
              _createVNode("img", {
                class: "levelImg",
                src: require('../../../../../assets/promiseFrame/batteryCar.png')
              }, null, 8, ["src"]),
              _hoisted_25,
              (_ctx.getData('soh') !== '-')
                ? (_openBlock(), _createBlock("span", {
                    key: 0,
                    class: "scoreLevel",
                    style: {background: _ctx.state.scoreLevel.value}
                  }, _toDisplayString(_ctx.state.scoreLevel.contTxt), 5))
                : _createCommentVNode("", true)
            ]),
            _hoisted_26
          ]),
          _createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, [
              _createVNode("p", null, [
                _hoisted_29,
                _createVNode("b", null, _toDisplayString(_ctx.getData('numberOfCycles')), 1),
                (_ctx.getData('numberOfCycles') !=='-')
                  ? (_openBlock(), _createBlock("span", _hoisted_30, "次"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("p", null, [
                _hoisted_31,
                _createVNode("b", null, _toDisplayString(_ctx.getData('kmRemain')), 1),
                (_ctx.getData('kmRemain') !=='-')
                  ? (_openBlock(), _createBlock("span", _hoisted_32, "Km"))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.state.activeTab === 1]
        ])
      ])
    ]),
    _createVNode("div", _hoisted_33, [
      _hoisted_34,
      _createVNode("div", _hoisted_35, [
        _createTextVNode(" NO." + _toDisplayString(_ctx.getData('reportCode')) + " ", 1),
        (_ctx.getData("reportGenDate"))
          ? (_openBlock(), _createBlock("span", _hoisted_36, " | " + _toDisplayString(_ctx.getData('reportGenDate').replace(/-/g,'.')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.state.isShowBatteryPop,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.isShowBatteryPop = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_37, [
          _createVNode("div", _hoisted_38, [
            _hoisted_39,
            _createVNode("i", {
              class: "iconfont icon-guanbi",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeBatteryPop && _ctx.changeBatteryPop(...args)))
            })
          ]),
          _hoisted_40
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})